<template>
  <div v-if="!loading">
    <ReviewAndSubmitComponent :updateKey="false" :infoKey="true">
      <h3 class="review-subheading">Order member cards</h3>
      <table class="review-and-submit-table">
        <tbody>
          <tr class="info">
            <th>Number of cards to be sent</th>
            <td>{{ numberOfCards }}</td>
          </tr>
          <tr v-if="!hideAddress">
            <th>Postal address</th>
            <td>{{ postalAddress }}</td>
          </tr>
        </tbody>
      </table>
    </ReviewAndSubmitComponent>
    <div class="form-page-nav">
      <section>
        <button class="secondary" @click="handleBackButton">Back</button>
        <button class="button" @click="handleSubmit">{{ buttonLabel }}</button>
      </section>
    </div>
  </div>
</template>

<script>
import { checkDesktopOrNot, isBuildCRM } from '@/utils';
import { ReviewAndSubmitComponent } from '@/components';

const isCRM = isBuildCRM();

export default {
  name: 'StepReviewAndSubmit',

  components: {
    ReviewAndSubmitComponent,
  },

  props: {
    loading: {
      type: Boolean,
    },

    apiError: {
      type: Boolean,
    },

    numberOfCards: {
      type: String,
      required: true,
    },

    postalAddress: {
      type: String,
      required: true,
    },

    handleBackButton: {
      type: Function,
      required: true,
    },

    handleSubmit: {
      type: Function,
      required: true,
    },
    hideAddress: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDesktop: true,
    };
  },

  computed: {
    buttonLabel() {
      return isCRM ? 'Request cards' : 'Order cards';
    },
  },

  methods: {
    checkDesktopOrNot,
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.isDesktop = this.checkDesktopOrNot();
    });
  },
};
</script>
